<template>
  <div>
    <v-card class="user-filter-card pa-5 elevation-3">
      <v-row>
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            id="searchUsername"
            v-model="searchInfo.username"
            :label="$t('search.username')"
            :placeholder="$t('search.usernamePlaceholder')"
            outlined
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            id="searchScanSn"
            v-model="searchInfo.scanSn"
            :label="$t('search.scanSn')"
            :placeholder="$t('search.scanSnPlaceholder')"
            outlined
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            id="searchScanType"
            v-model="searchInfo.scanType"
            :items="scanTypeList"
            item-text="text"
            item-value="value"
            :label="$t('general.scanType')"
            outlined
            clearable
          />
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-dialog
            ref="dateFromDialog"
            v-model="showDateFromPicker"
            :return-value.sync="searchInfo.scanDateFrom"
            width="320px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="searchInfo.scanDateFrom"
                :label="$t('search.dateFrom')"
                readonly
                outlined
                clearable
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="searchInfo.scanDateFrom"
              :locale="convertLocale(currentLocale, 'bcp47')"
              :max="searchInfo.scanDateEnd"
              scrollable
              @input="setDate(searchInfo.scanDateFrom, 'dateFromDialog', showDateFromPicker)"
            />
          </v-dialog>
        </v-col>

        <v-col
          cols="12"
          sm="4"
        >
          <v-dialog
            ref="dateEndDialog"
            v-model="showDateEndPicker"
            :return-value.sync="searchInfo.scanDateEnd"
            width="320px"
          >
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="searchInfo.scanDateEnd"
                :label="$t('search.dateEnd')"
                readonly
                outlined
                clearable
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-date-picker
              v-model="searchInfo.scanDateEnd"
              :locale="convertLocale(currentLocale, 'bcp47')"
              :min="searchInfo.scanDateFrom"
              scrollable
              @input="setDate(searchInfo.scanDateEnd, 'dateEndDialog', showDateEndPicker)"
            />
          </v-dialog>
        </v-col>
      </v-row>

      <v-card-actions>
        <v-btn
          color="primary"
          @click="search()"
        >
          {{ $t('common.search') }}
        </v-btn>
        <v-btn
          color="accent darken-3"
          @click="clear()"
        >
          {{ $t('common.clear') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<i18n src="./locales/en.json"></i18n>
<i18n src="./locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'

export default {
  name: 'ScanRecordFilter',
  mixins: [ErrorDisplay],
  data: function () {
    return {
      searchInfo: {
        username: null,
        scanSn: null,
        scanType: null,
        scanDateFrom: null,
        scanDateEnd: null
      },
      scanTypeList: [
        { value: 'product', text: this.$t('general.product') },
        { value: 'certificate', text: this.$t('general.certificate') }
      ],
      showDateFromPicker: false,
      showDateEndPicker: false
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    setDate (date, ref, modal) {
      this.$refs[ref].save(date)
      modal = false
    },
    search () {
      this.$emit('search', this.searchInfo)
    },
    add () {
      this.$emit('add')
    },
    clear () {
      for (const key in this.searchInfo) {
        this.searchInfo[key] = null
      }
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>
  .user-filter-card {
    width: 100%
  }
</style>
